module.exports = __webpack_public_path__ + "static/media/Mobile_Data_DESENVOLVIMENTO_DE_ARQ._DE_INTEG._COM_APACHE_E_KAFKA_SERVICE.c2344c2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/desenvolvimentoArq/Mobile_Data_DESENVOLVIMENTO_DE_ARQ._DE_INTEG._COM_APACHE_E_KAFKA_SERVICE.png
// module id = 80
// module chunks = 0